import React from "react";

export function DashboardTypeColumnFormatter(cellContent, row) {
    if (!cellContent || cellContent === "NA") {
        return (
            <span className="badge badge-light-secondary">
                <i className="fas fa-ban me-1"></i>
                No Dashboard
            </span>
        );
    }

    // Map dashboard types to colors and icons
    const dashboardConfig = {
        "Admin Dashboard": {
            color: "danger",
            icon: "fa-user-shield"
        },
        "Finance Dashboard": {
            color: "success",
            icon: "fa-dollar-sign"
        },
        "Manager Dashboard": {
            color: "primary",
            icon: "fa-users-cog"
        },
        "Supervisor Dashboard": {
            color: "info",
            icon: "fa-clipboard-check"
        },
        "No Dashboard": {
            color: "secondary",
            icon: "fa-ban"
        }
    };

    const config = dashboardConfig[cellContent] || {
        color: "dark",
        icon: "fa-th-large"
    };

    return (
        <span className={`badge badge-light-${config.color}`}>
            <i className={`fas ${config.icon} me-1`}></i>
            {cellContent}
        </span>
    );
}
